import { NuxtAxiosInstance } from '@nuxtjs/axios'
import processError from '~/helpers/processError'
import { IntegrationThreeaseTicketRepo } from '~/types'

const ENDPOINT = 'therapists/integrations/threease_ticket/quick_login'

export default (
  $axios: NuxtAxiosInstance,
  $sentry: any
): IntegrationThreeaseTicketRepo => ({
  async quickLogin(next_identifier: string, next_options: any) {
    try {
      const res = await $axios.post(ENDPOINT, {
        next_identifier,
        next_options,
      })
      return res.data
    } catch (error) {
      processError(error, $sentry)
    }
  },
})
